import React, { ReactElement } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { HeroAboutQuery } from '@/../graphql-types';
import { heroImg, heroImgWrapper } from '@/styles/hero.module.css';
import { HeroProps } from './types';

const HeroAbout = ({
  className = heroImgWrapper,
  imgClassName = heroImg,
}: HeroProps): ReactElement => {
  const { desktop } = useStaticQuery<HeroAboutQuery>(graphql`
    query HeroAbout {
      desktop: file(relativePath: { eq: "hero-about.jpg" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
        }
      }
    }
  `);

  return (
    <GatsbyImage
      image={desktop.childImageSharp.gatsbyImageData}
      alt="Boce ulja"
      loading="eager"
      className={className}
      imgClassName={imgClassName}
    />
  );
};

export default HeroAbout;
